import axios from "axios";
import Grid from "@mui/material/Grid";
import ReactGA from 'react-ga4';
import HeaderUser from "./header-user";
import DrawerUser from "./Drawer";
import ModalDialogComponent from "../../components/dialog/dialog-component";
import { Outlet } from "react-router-dom";
import React, { useContext, useState, useEffect } from "react";
import { UserContext, UserContextProvider } from "../../contexts/context-layout-user";
import jwt_decode from "jwt-decode";
import { casesCreated } from "../../actions/casesError";
import NotificationListener from "../../components/notification/NotificationListener";
import VideoPlayer from "../../components/video-demo/video-demo";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from "@mui/material";
import GeneratorModule from "./generators";


function LayoutUserInit(props) {
  const data = props.data;
  const reminderMessage = props.reminderMessage;

  const [filteredCases, setFilteredCases] = useState([]);
  const [filteredLayers, setFilteredLayers] = useState([]);
  const { generators } = useContext(UserContext);

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <HeaderUser
            {...props}
            reminderMessage={reminderMessage}
            data={data}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={0}>
          {generators ? (
            <>
              <GeneratorModule  {...props} />
            </>
          ) : (
            <>
              <Grid item xs={3}>
                <DrawerUser
                  filteredCases={filteredCases}
                  setFilteredCases={setFilteredCases}
                  filteredLayers={filteredLayers}
                  setFilteredLayers={setFilteredLayers}
                  {...props}
                />
              </Grid>
              <Grid
                item
                xs={9}
                id="detail"
                style={{
                  padding: 30,
                  paddingTop: 15,
                  height: "calc(100vh - 67px)",
                }}
              >
                <Outlet />
              </Grid>
            </>
          )}
          </Grid>
        </Grid>
      </Grid>
      <NotificationListener {...props} />
    </>
  );
}

export default function LayoutUser(props) {

  const [caseSelectOwner, setCaseSelectOwner] = useState(null);
  const [loader, setLoader] = useState(false);
  const [modalMessages, setModalMessages] = useState(false);
  const [message, setMessage] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [open, setOpen] = useState(false);

  const [data, setData] = useState({});
  const [reminderMessage, setReminderMessage] = useState(false);

  const [t, i18next] = useTranslation("global")
  const language = localStorage.getItem('i18nextLng') || 'es'

  useEffect(() => {
    const caseSelect = window.location.search
      ? window.location.search.split("?")[1].split("case=")[1]
      : null;

    if (caseSelect) {
      setLoader(true);
      setCaseSelectOwner(caseSelect);
    }

    let token = localStorage.getItem("saxToken");
    const infoUser = token ? jwt_decode(token) : null;

    if (infoUser) {
      const endDatee = new Date(infoUser.licenseExpirationTime);
      const endDateYear = endDatee.getFullYear();
      const endDateMonth = endDatee.getMonth() + 1;
      const endDateDay = endDatee.getDate() + 1;
      const endDate3M = new Date(endDateYear, endDateMonth - 4, endDateDay);
      const actualDate = new Date(Date.now());
      const isDemo = infoUser.isDemo ? " demo" : "";

      const dataUser = {
        name: infoUser.name,
        lastName: infoUser.lastName,
        email: infoUser.email,
        company: infoUser.typeAccount,
        isDemo: infoUser.isDemo ? "Sí" : "No",
        endDateYear: endDateYear,
        endDateMonth: endDateMonth,
        endDateDay: endDateDay,
      };

      setData(dataUser);

      if (endDate3M <= actualDate) {
        setReminderMessage(true);

        if (localStorage.getItem("control")) {
          setModalMessages(true);
          setMessage(
            `Recuerde que su licencia${isDemo} expira el ${endDateDay}/${endDateMonth}/${endDateYear}. Contacte el administrador para actualizar su licencia.`
          );
          localStorage.removeItem("control");
        }
      } else {
        setModalMessages(false);
        localStorage.removeItem("control");
      }
    }

    if (caseSelect && caseSelect.startsWith("ERROR")) {
      fetchErrorFromDB(caseSelect);
      setModalTitle("Error en la Simulación");
    }

    window.dataLayer.push({ event: 'analytics-consent', consent: 'granted' });
    ReactGA.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'personalization_storage': 'granted',
      'functionality_storage': 'granted',
      'security_storage': 'granted'
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem('firtsVideDemo', 'true');
  };

  const fetchErrorFromDB = async (errorKey) => {
    try {
      const response = await casesCreated(errorKey);
      if (response && response.message) {
        let formattedMessage = response.message;
        formattedMessage = `
                    Se ha detectado un problema con los datos de entrada de la simulación
                    Por favor, revise los siguientes detalles y corrija los errores antes de intentar nuevamente:<br/><br/>

                    ${response.message
            .split(";")
            .map((err) => `- ${err}`)
            .join("<br/>")}

                    <br/><br/>
                    Si necesita ayuda, contacte al soporte técnico: <strong>info@sax.com.co</strong>
                `;

        setMessage(formattedMessage);
        setModalMessages(true);
      }
    } catch (error) {
      console.error("Error al obtener datos de la base de datos:", error);
    }
  };

  return (
    <UserContextProvider case={caseSelectOwner}>
      <ModalDialogComponent
        view={modalMessages}
        tittle={modalTitle || "Notificación"}
        message={<div dangerouslySetInnerHTML={{ __html: message }} />}
        buttons={[
          {
            value: "Aceptar",
            onclick: () => {
              setModalMessages(false);
              props.infoUser.isDemo && !localStorage.getItem('firtsVideDemo') ? setOpen(true) : setOpen(false);
            },
          },
        ]}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            width: 'auto',
            maxWidth: 'none'
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {t('modals.videoDemo.title')}
          <Divider />
        </DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-description">
            {t('modals.videoDemo.description')}
            <br /> <br />
            <VideoPlayer />
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            {t('modals.videoDemo.accept')}
          </Button>
        </DialogActions>
      </Dialog>
      <LayoutUserInit {...props} data={data} reminderMessage={reminderMessage} />
    </UserContextProvider>
  );
}
